import CryptoJS from 'crypto-js';

class SMTrackHelper {
  
  static outboundLink(url) {
    if (typeof ga != 'function') return;
    ga('send', 'event', 'outbound', 'click', url, {'hitCallback':
      function () {
        document.location = url;
      }
    });
  }

  static pageView(url) {
    if (typeof ga != 'function') return;
    if (!url) url = location.pathname;
    ga('send', 'pageview', url);
  }

  static pageEvent(label, value){
    if (typeof ga != 'function') return;
    ga('send', 'event', 'button', 'click', label, value);
  }
  
  //criteo
  static criteoHome(email){
    if (SpaceMarket.Config.Env != "production") return;
    const hashedEmail = (email) ? CryptoJS.MD5(email).toString() : "";
    window.criteo_q = window.criteo_q || [];
    window.criteo_q.push(
      { event: "setAccount", account: 27638 },
      { event: "setHashedEmail", email: hashedEmail },
      { event: "setSiteType", type: "d" },
      { event: "viewHome" }
    );
  }
  
  static criteoItem(email, roomId){
    if (SpaceMarket.Config.Env != "production") return;
    const hashedEmail = (email) ? CryptoJS.MD5(email).toString() : "";
    window.criteo_q = window.criteo_q || [];
    window.criteo_q.push(
      { event: "setAccount", account: 27638 },
      { event: "setHashedEmail", email: hashedEmail },
      { event: "setSiteType", type: "d" },
      { event: "viewItem", item: roomId }
    );
  }
  
  static criteoList(email, rooms){
    if (SpaceMarket.Config.Env != "production") return;
    const hashedEmail = (email) ? CryptoJS.MD5(email).toString() : "";
    let roomIds = [];
    for (let i = 0; i < 3; i++){
      if(!rooms[i]) break;
      roomIds.push(rooms[i].uid);
    }
    window.criteo_q = window.criteo_q || [];
    window.criteo_q.push(
      { event: "setAccount", account: 27638 },
      { event: "setHashedEmail", email: hashedEmail },
      { event: "setSiteType", type: "d" },
      { event: "viewList", item: roomIds }
    );
  }

  static criteoBasket(email, itemId, itemPrice, itemQuantity){
    if (SpaceMarket.Config.Env != "production") return;
    const hashedEmail = (email) ? CryptoJS.MD5(email).toString() : "";
    window.criteo_q = window.criteo_q || [];
    window.criteo_q.push(
            { event: "setAccount", account: 27638 },
            { event: "setHashedEmail", email: hashedEmail },
            { event: "setSiteType", type: "d" },
            { event: "viewBasket", item: [
                  { id: itemId, price: itemPrice, quantity: itemQuantity },
    ]});
  }

  static criteoMultipleBasket(email, itemIds, itemPrice, itemQuantity){
    if (SpaceMarket.Config.Env != "production") return;
    const items = itemIds.map(function(id){
      return { id: id, price: itemPrice, quantity: itemQuantity };
    });
    const hashedEmail = (email) ? CryptoJS.MD5(email).toString() : "";
    window.criteo_q = window.criteo_q || [];
    window.criteo_q.push(
            { event: "setAccount", account: 27638 },
            { event: "setHashedEmail", email: hashedEmail },
            { event: "setSiteType", type: "d" },
            { event: "viewBasket", item: items }
    );
  }

  static criteoTransaction(email, transactionId, itemId, itemPrice, itemQuantity){
    if (SpaceMarket.Config.Env != "production") return;
    const hashedEmail = (email) ? CryptoJS.MD5(email).toString() : "";
    window.criteo_q = window.criteo_q || [];
    window.criteo_q.push(
            { event: "setAccount", account: 27638 },
            { event: "setHashedEmail", email: hashedEmail },
            { event: "setSiteType", type: "d" },
            { event: "trackTransaction" , id: transactionId, item: [ 
                  { id: itemId, price: itemPrice, quantity: itemQuantity }
    ]});
  }

}
export default SMTrackHelper;



// WEBPACK FOOTER //
// ./app/javascript/components/helpers/SMTrackHelper.js